export const SITE = {
  name: "MIKA SOLUTION",
  shortName: "Mika Solution",
  url: "https://mikasolution.id",
  tagline: "Temukan Jalan Keluar, Bangun Kembali Ketenangan Finansial.",
  parent: { name: "Mitra Karya Law Office", url: "https://mitrakaryalawoffice.com/" },
  // Source: mitrakaryalawoffice.com
  whatsapp: "6281214240919",
  phone: "+62 (0251) 20279984",
  phoneHref: "tel:+6225120279984",
  email: "info@mikasolution.id",
  instagram: "mikasoulutionofficial",
  instagramUrl: "https://www.instagram.com/mikasoulutionofficial/",
  mapsEmbed: "https://maps.google.com/maps?q=mitra%20karya%20law%20office&t=m&z=17&output=embed&iwloc=near",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Mitra+Karya+Law+Office",
  address: "Jl. Raya Parung No.47, Ruko The Boulevard Blok A1, Jabon Mekar, Kec. Parung, Kabupaten Bogor",
  hours: "Senin–Jumat 08.00–17.00 · Sabtu 08.00–14.00",
};

export const WA_MESSAGES = {
  default: "Halo Mika Solution, saya ingin berkonsultasi mengenai kondisi kewajiban finansial saya.",
  pinjol: "Halo Mika Solution, saya ingin berkonsultasi mengenai kewajiban pinjaman online saya.",
  "kartu-kredit": "Halo Mika Solution, saya ingin berkonsultasi mengenai kewajiban kartu kredit saya.",
  kta: "Halo Mika Solution, saya ingin berkonsultasi mengenai kewajiban Kredit Tanpa Agunan (KTA) saya.",
};

export const waLink = (key = "default", custom) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(custom || WA_MESSAGES[key] || WA_MESSAGES.default)}`;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
